import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { COMPANY } from "@/lib/constants";

const Datenschutz = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main data-testid="datenschutz-page" className="pt-32 pb-24 bg-white min-h-screen">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <Link to="/" data-testid="datenschutz-back-link" className="inline-flex items-center gap-2 text-[#1FA3B5] font-medium hover:gap-3 transition-all">
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>

        <h1 className="font-heading text-4xl lg:text-5xl font-bold text-slate-900 mt-8">Datenschutzerklärung</h1>
        <p className="mt-3 text-slate-500">Stand: {new Date().toLocaleDateString("de-DE", { month: "long", year: "numeric" })}</p>

        <div className="mt-10 space-y-8 text-slate-700 leading-relaxed">
          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">1. Verantwortlicher</h2>
            <p>
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br />
              {COMPANY.legalName}, {COMPANY.street}, {COMPANY.zip} {COMPANY.city}<br />
              E-Mail: <a href={`mailto:${COMPANY.email}`} className="text-[#1FA3B5] hover:underline">{COMPANY.email}</a>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">2. Zugriffsdaten</h2>
            <p>
              Beim Aufruf unserer Website werden durch den Internet-Browser automatisiert Daten an den Server dieser Website gesendet
              und zeitlich begrenzt in einem Log-File gespeichert (IP-Adresse, Datum/Uhrzeit, aufgerufene Seite, übertragene Datenmenge,
              Browser-Typ). Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse am stabilen Betrieb).
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">3. Kontaktaufnahme per WhatsApp</h2>
            <p>
              Über das Kontaktformular wird Ihre Nachricht als vorgefertigter Text an WhatsApp übergeben. Die Übermittlung erfolgt
              ausschließlich durch Sie selbst, sobald Sie in WhatsApp auf „Senden" klicken. Beachten Sie, dass WhatsApp ein Dienst der
              Meta Platforms Ireland Ltd. ist und Daten unter Umständen außerhalb der EU verarbeitet werden. Details finden Sie in der
              Datenschutzerklärung von WhatsApp.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">4. Kontaktaufnahme per E-Mail oder Telefon</h2>
            <p>
              Bei Kontaktaufnahme per E-Mail oder Telefon werden Ihre Angaben zur Bearbeitung der Anfrage und für den Fall von
              Anschlussfragen gespeichert. Rechtsgrundlage: Art. 6 Abs. 1 lit. b und f DSGVO.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">5. Cookies</h2>
            <p>
              Diese Website verwendet ausschließlich technisch notwendige Cookies für den sicheren und reibungslosen Betrieb der Seite.
              Es findet kein Tracking zu Werbezwecken statt.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">6. Ihre Rechte</h2>
            <p>
              Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO), Einschränkung
              der Verarbeitung (Art. 18 DSGVO), Datenübertragbarkeit (Art. 20 DSGVO) und Widerspruch (Art. 21 DSGVO). Wenden Sie sich
              hierfür an die oben genannten Kontaktdaten. Außerdem steht Ihnen ein Beschwerderecht bei der zuständigen Datenschutz-
              Aufsichtsbehörde zu.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">7. Externe Inhalte</h2>
            <p>
              Bilder werden teilweise von externen Diensten (z. B. Pexels, Google Fonts) eingebunden. Dabei kann die IP-Adresse an den
              jeweiligen Anbieter übermittelt werden. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
            </p>
          </section>
        </div>
      </div>
    </main>
  );
};

export default Datenschutz;
